<header>
    <h3>{{listTitle}}</h3>
</header>

<ul>
    <li *ngFor="let partition of partitions; index as i">
        <app-hapy-cursor
            *ngIf="partition.partitionDetails.articleType === articleType && partition.isMainCursor"
            [cursor]="partition.cursorParameters"
            [mode]="partition.simulationValues.mode"
            [value]="partition.simulationValues.indice"
            [label]="partition.partitionDetails.text?.shortLabel"
            [isDisabled]="!partition.isMainEditable || !partition.simulationValues.isEditable"
            [isNotEditable]="!partition.simulationValues.isEditable"
            (buttonClicked)="onApplyPercent($event, partition)">
        </app-hapy-cursor>
    </li>
</ul>

<!-- (valueChanged)="onApplyPercent($event, partition)" -->
